/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { mobileUtils } from '@blend/consumer-components';
import { isOnboardingRoute, isSigningRoomRoute, isNotaryRoute } from '@utils/routing';

export enum Orientations {
  portrait = 'portrait',
  landscape = 'landscape',
}

// @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/orientation
export const getOrientation = (window: Window) =>
  window.innerHeight >= window.innerWidth ? Orientations.portrait : Orientations.landscape;

export const getMinDesktopWidth = () => {
  switch (true) {
    case isSigningRoomRoute(window.location.pathname):
      return 1100;
    case isOnboardingRoute(window.location.pathname):
      return mobileUtils.isMobileDevice() ? 1100 : 568;
    case isNotaryRoute(window.location.pathname):
      return 1100;
    default:
      return 0;
  }
};

const minDesktopWidth = getMinDesktopWidth();

export const breakpointWidths = {
  mobile: minDesktopWidth - 1,
  desktop: minDesktopWidth,
};

export const mediaOrientations = {
  portrait: `@media (orientation: ${Orientations.portrait})`,
  landscape: `@media (orientation: ${Orientations.landscape})`,
};

export const mediaBreakpoints = {
  mobile: `@media (max-width: ${breakpointWidths.mobile}px)`,
  desktop: `@media (min-width: ${breakpointWidths.desktop}px)`,
};
